/* istanbul ignore file */
import { createClient, fetchExchange } from 'urql';
import { createGqlApiUrl } from './createGqlApiUrl';

/**
 * Use this client for on-off requests or for requests that should not affect the graphcache to keep the queries, mutations and cache clean
 * @returns a urql client with the default fetchExchange and the default url
 */
export const createTinyUrqlClient = () =>
  createClient({ url: createGqlApiUrl(), exchanges: [fetchExchange] });
